import * as React from 'react';

import './index.scss';

interface IPathEditBarProps {
  isPathClosed: boolean;
  onClosePath: () => void;
  onFinishEditing: () => void;
}

const PathEditBar: React.FC<IPathEditBarProps> = ({
  isPathClosed,
  onClosePath,
  onFinishEditing,
}: IPathEditBarProps) => {
  return (
    <div className="path-edit-bar">
      <button
        type="button"
        className="path-edit-bar-action"
        onClick={onClosePath}
        disabled={isPathClosed}
      >
        Close Path
      </button>
      <div className="path-edit-bar-divider" />
      <button
        type="button"
        className="path-edit-bar-action path-edit-bar-primary"
        onClick={onFinishEditing}
      >
        End Editing
      </button>
    </div>
  );
};

export default PathEditBar;
